module.exports = __webpack_public_path__ + "static/media/install.0df6c593.png";